// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/kpi-departments/requests",
  Create: "/pyr/kpi-departments/requests",
  Update: "/pyr/kpi-departments/requests",
  Detail: "/pyr/kpi-departments/requests",
  Approve: "/pyr/kpi-departments/requests/approve",
};
